var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-anchor",
    style: _vm.styles,
    attrs: {
      "id": _vm.$attrs._id
    }
  }, [_c('div', {
    staticClass: "tag-line",
    style: _vm.lineStyle
  }), _vm.tailPosition !== 'none' ? _c('div', {
    staticClass: "tag-dot",
    style: {
      backgroundColor: _vm.tailColourEffective
    }
  }) : _vm._e(), _c('div', {
    staticClass: "tag-rich",
    class: _vm.classes,
    style: _vm.labelStyle,
    on: {
      "click": _vm.triggerAction
    }
  }, [_c('div', {
    staticClass: "tag-rich__inner",
    class: {
      'tag-rich__inner--expand': _vm.active && !_vm.action.method
    }
  }, [_vm.label ? _c('div', {
    staticClass: "tag-rich__content-col",
    class: [{
      'tag-rich__content-col--overlay-hidden': _vm.overlayContent && !_vm.label[_vm.activeLanguage.code] && !_vm.description[_vm.activeLanguage.code]
    }],
    style: [{
      backgroundColor: !_vm.overlayContent ? _vm.backgroundColour : 'inherit'
    }, {
      color: _vm.textColour
    }],
    attrs: {
      "dir": _vm.activeLanguage.dir
    }
  }, [_c('div', {
    staticClass: "tag-rich__label",
    domProps: {
      "innerHTML": _vm._s(_vm.label[_vm.activeLanguage.code] || _vm.label['en'])
    }
  }), _c('div', {
    staticClass: "tag-rich__description",
    domProps: {
      "innerHTML": _vm._s(_vm.description[_vm.activeLanguage.code] || _vm.description['en'])
    }
  }), (_vm.moreInformation[_vm.activeLanguage.code] || _vm.moreInformation['en'] || _vm.qrUrl) && !_vm.overlayContent ? _c('div', {
    staticClass: "tag-rich__info-icon"
  }, [_vm._v("[MORE]")]) : _vm._e()]) : _vm._e(), _vm.useQRTemplate ? [!_vm.overlayContent ? _c('div', {
    staticClass: "tag-rich__content-col-extra",
    attrs: {
      "dir": _vm.activeLanguage.dir
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "tag-rich__qr tag-rich__qr--centered"
  }, [_c('qrcode-vue', {
    attrs: {
      "render-as": "canvas",
      "background": "#fff",
      "value": _vm.qrUrl
    }
  })], 1)]) : _vm._e()] : _vm._e(), !_vm.useQRTemplate ? [(_vm.moreInformation[_vm.activeLanguage.code] || _vm.moreInformation['en']) && !_vm.overlayContent ? _c('div', {
    staticClass: "tag-rich__content-col-extra",
    attrs: {
      "dir": _vm.activeLanguage.dir
    }
  }, [_vm.qrUrl ? _c('div', {
    staticClass: "tag-rich__qr"
  }, [_c('qrcode-vue', {
    attrs: {
      "render-as": "canvas",
      "background": "#fff",
      "value": _vm.qrUrl
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "tag-rich__description",
    domProps: {
      "innerHTML": _vm._s(_vm.moreInformation[_vm.activeLanguage.code] || _vm.moreInformation['en'])
    }
  })]) : _vm._e()] : _vm._e(), _vm.asset ? _c('div', {
    staticClass: "tag-rich__asset-col"
  }, [_c('div', {
    staticClass: "tag-rich__asset-col__overlay",
    style: _vm.overlayOpacityStyle
  }), _c('div', {
    staticClass: "tag-rich__asset"
  }, [_vm.icon ? _c('div', {
    staticClass: "tag-rich__action-icon"
  }, [_c('fa', {
    attrs: {
      "icon": _vm.icon
    }
  })], 1) : _vm._e(), _vm.asset.type === 'image' ? _c('img', {
    staticClass: "asset-cover",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath + _vm.asset.path)
    }
  }) : _vm._e(), _vm.asset.type === 'video' ? _c('div', {
    staticClass: "tag-rich__asset-clip"
  }, [_c('video', {
    staticClass: "asset-cover",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath + _vm.asset.path),
      "autoplay": "",
      "muted": "",
      "loop": "",
      "disablePictureInPicture": "",
      "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
    },
    domProps: {
      "muted": true
    }
  })]) : _vm._e()])]) : _vm._e()], 2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-rich__description tag-rich__description--centered"
  }, [_vm._v("Scan QR code"), _c('br'), _vm._v("for more information")]);

}]

export { render, staticRenderFns }